import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const egoi = defineConnector({
  identifier: "egoi",
  name: "E-goi",
  tagLine: "Marketing automation",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.egoiapp\\.com/.*",
  auth: (app) => headerAuth([{ name: "Apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [E-goi](https://app.e-goi.com/), go to **Integrations → API Keys** and copy your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.egoiapp.com/my-account",
  },
});
